import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let getChildrenList = async () => {

    return request.get(`/api/childrens/list/${authStore.decodeJwt.userId}`, true).then(r => {
        return rThen(r)
    })
}